// StaffRoute.tsx
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getUserGroups } from '../utils/AuthUtils'

interface StaffRouteProps {
  children: JSX.Element;
  fallbackPath?: string;
}

const StaffRoute = ({ children, fallbackPath = "/unauthorized" }: StaffRouteProps) => {
  const [isStaff, setIsStaff] = useState<boolean | null>(null);

  useEffect(() => {
    getUserGroups()
      .then((groups) => setIsStaff(groups.includes('Staff') || groups.includes('Administrators')))
      .catch(() => setIsStaff(false));
  }, []);

  if (isStaff === null) return <div>Loading...</div>;
  if (!isStaff) return <Navigate to={fallbackPath} replace />;

  return children;
};
export default StaffRoute;
